<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 13.3 13.299" :class="[`${prefix}-icon`, `${prefix}-icon-submit`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.0427,0.0442564L0.68539,3.53749C-0.10491,3.78062,-0.248643,4.83716,0.44809,5.28259L3.80366,7.42762C4.16182,7.65653,4.62727,7.6257,4.95212,7.35156L9.14022,3.81749C9.36726,3.62592,9.67362,3.93206,9.48206,4.15932L5.94822,8.34812C5.67412,8.67292,5.64338,9.13833,5.87239,9.49636L8.01696,12.8515C8.46216,13.548,9.51892,13.4042,9.76206,12.6142L13.2553,1.25712C13.4842,0.512556,12.787,-0.184644,12.0427,0.0442564Z"/></svg>
</template>
<script>

export default {
  name: 'IconSubmit',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
